module.exports = __webpack_public_path__ + "static/media/mittens.abe49dec.png";